import React, { Component } from 'react';
import {
    Row, Col
} from "reactstrap";

import Registry from "../../../../Utils/Registry";
import Helpers from "../../../../Utils/Helpers";
import {NotificationManager} from "react-notifications";

import ExportFormFormat from "../Forms/Format";
import ExportFormColumns from "../Forms/Columns";
import ExportFormType from "../Forms/Type";
import ExportFormUniq from "../Forms/Uniq";
import ExportFormRecurrent from "../Forms/Rec";
import { ExportConfirmationModal } from "../Modal/Confirmation";


export default class ExportInvoiceForm extends Component {
    static defaultProps = {
        onCreateRec: () => {}
    };

    constructor(props) {
        super(props);

        this.headers = this.props.headers;

        this.state = {
            keys: Object.keys(this.headers),
            loading: false,
            exportType: 'unique',
            format: "excel",
            noColumnError: false,
            sentTo: [],
            showConfirmation: false
        };

        this.api = Registry.registered("api");
    }

    exportOneTime = (dateMin, dateMax, emails, title) => {
        if(!this.state.keys.length){
            this.setState({noColumnError: true});
            return;
        }
        else 
            this.setState({loading: true, noColumnError: false});

        let date_filter = "";
        
        if(dateMin){
            date_filter = "&dates="+dateMin;
            if(dateMax)
                date_filter += "," + dateMax;
        }

        const { keys, format } = this.state;
        const { type } = this.props;
        const toEmails = emails.join(",");

        const URL = `/invoices/export?type=${type}&v=${Helpers.uniqId()}&is_business=1&format=${format}&name=${title}&send_to=${toEmails}&keys=${keys.join(",")}${date_filter}`;
        //const FILENAME = `${title}.xlsx`;
        this.api.get(URL)
            .then(() => this.setState({loading: false, showConfirmation: true, sentTo: emails}))
            .catch(_ => {
                this.setState({loading: false});
                NotificationManager.error("Une erreur est survenue, impossible d'exporter les données");
            });
    };

    createRecExport = data => {
        let user = Registry.registered("user");
        const { onCreateRec } = this.props;

        if(user){
            if(!this.state.keys.length){
                this.setState({noColumnError: true});
                return;
            }
            else 
                this.setState({loading: true, noColumnError: false});

            let recType = 'invoices';
            if(this.props.type === "advanced")
                recType = 'advanced-invoices';

            this.api.post(`/business/${user.business_id}/recurrent_export`, {
                ...data,
                keys: this.state.keys.join(","),
                type: recType,
                format: this.state.format
            })
                .then(_ => {
                    this.setState({loading: false});
                    NotificationManager.success("Export recurrent créé");
                    onCreateRec && onCreateRec();
                })
                .catch(_ => {
                    NotificationManager.error("impossible de créer l'export recurrent");
                    this.setState({loading: false});
                });
        }
        else
            NotificationManager.error("Impossible de faire la demande");
    };

    render() {
        const { exportType, keys, loading, noColumnError, showConfirmation, sentTo } = this.state;
        const { type } = this.props;
        
        return <div>

            <ExportConfirmationModal shown={showConfirmation} onCloseRequest={_ => this.setState({showConfirmation: false})} sentTo={sentTo} />

            { /* <div className="d-flex justify-content-between pad-b-10">
                <h2 className="ty-subtitle">
                    Export des factures { type === "advanced" ? "detaillées" : ""}
                </h2>
            </div> */ }
            
            <div className="ty-block">
                <Row>
                    <Col md={6}>
                        { noColumnError && <p className="red">Vous devez choisir au moins une colonne &agrave; exporter</p> }
                        <ExportFormColumns 
                            columns={this.headers} 
                            defaultSelected={keys}
                            onListChange={list => {this.setState({keys: list});}} 
                        />
                    </Col>
                    <Col md={6} className="relative">
                        <ExportFormType 
                            onExportTypeChanged={eType => {this.setState({exportType: eType});}} 
                        />

                        <br />

                        <ExportFormFormat 
                            onExportFormatChanged={eFormat => {this.setState({format: eFormat});}} 
                        />
                        
                        <br />

                        {
                            exportType === 'unique' ?
                                <ExportFormUniq loading={loading} onSubmit={this.exportOneTime} />
                                :
                                <ExportFormRecurrent onSubmit={this.createRecExport} />
                        }
                    </Col>
                </Row>
            </div>
        </div>;
    }
}


ExportInvoiceForm.defaultProps = {
    type: 'classic',
    headers: {},
    onCreateRec: () => {}
}


// WEBPACK FOOTER //
// ./src/components/Operations/Export/Invoice/Form.js